import { demoFile, component, componentWithVariants, variant, feature } from 'system/demo';
import { CommentSorterTitle, CommentSorter, CommentsSortFeature } from '../comments-sort';
import { SimpleCommentsStructure } from 'structure/simple-comments';

demoFile('open-modules/cbcrc/feature/comments/comments-sort');

const comments = [
    { key: '1', from: 'a', text: 'First', time: 1 },
    { key: '2', from: 'b', text: 'Second', time: 2 }
];
const upvote = [{ key: 'u1', from: 'a', comment: '2' }];

feature('Comment Sorting', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    features: { commentssort: true },
    state: { collections: { comment: comments, upvote } }
});

component('CommentSorterTitle', CommentSorterTitle);

componentWithVariants('CommentSorter', CommentSorter, {}, [
    variant('Recent', { state: { collections: { comment: comments } } }),
    variant('Oldest', { state: { collections: { comment: comments }, sessionData: { commentSortValue: { value: 'oldest' } } } }),
    variant('Popular', { state: { collections: { comment: comments, upvote }, sessionData: { commentSortValue: { value: 'popular' } } } })
]);
